module.exports = __webpack_public_path__ + "static/media/mileage_2_2.0fee590a.png";